<app-header></app-header>
<div class="container">
    <app-banner></app-banner>
    <app-courses-section [categories]="categories"></app-courses-section>
    <app-testimonials></app-testimonials>
	<app-middle-banner></app-middle-banner>
    <app-footer></app-footer>
</div>
